import { useReplyDraftTourActions } from './replyDraftTourContext';
import { REPLY_DRAFT_TOUR_SEGMENTS, segmentForTourKey } from '../../model/tour';
import { REPLY_DRAFT_COPY, tourStepText } from '../copy';

import { TourTooltipCard } from '@/components/TourTooltipCard';
import type { SpotlightStep } from '@/components/spotlight/SpotlightTour';

/**
 * The card beside each highlight of the reply draft tour.
 *
 * The last step of the position segment says "Got it" rather than Next: the
 * tour then waits for the expert to pick a position, and the points segment
 * opens on the step that follows. Skip is offered everywhere but the tour's
 * very last step.
 */
export function ReplyDraftTourTooltip({ step }: { step: SpotlightStep }) {
  const { advance, back, skip } = useReplyDraftTourActions();

  const segment = segmentForTourKey(step.tourKey);

  const { zone, isFirstStep, isLastStep } = step;

  const text = segment ? tourStepText(segment, zone) : undefined;

  if (!segment || !text) {
    return null;
  }

  const isFinalStep = isLastStep && REPLY_DRAFT_TOUR_SEGMENTS[segment].next === 'done';

  let primaryLabel = REPLY_DRAFT_COPY.tour.next;

  if (isFinalStep) {
    primaryLabel = REPLY_DRAFT_COPY.tour.done;
  } else if (isLastStep) {
    primaryLabel = REPLY_DRAFT_COPY.tour.gotIt;
  }

  return (
    <TourTooltipCard
      text={text}
      textRef={step.focusRef}
      primaryLabel={primaryLabel}
      onPrimary={() =>
        advance({ segment, zone, isLastStep, handleNext: step.next, handleStop: step.stop })
      }
      onSkip={isFinalStep ? undefined : () => skip(segment, zone, step.stop)}
      onBack={isFirstStep ? undefined : () => back(segment, zone, step.prev)}
    />
  );
}
